import React from "react";

export default function Call() {
  return (
    <>
      <div className="AT-cta-section">
        <h3 className="AT-cta-title">Ready to Evaluate DDW Systems?</h3>
        <p className="AT-cta-desc" style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '750px', margin: '1rem auto 2.5rem', lineHeight: '1.6', fontSize: '1.15rem' }}>
          Apply for controlled demo access or book a commercial call to discuss deployment and licensing options.
        </p>
        <div className="AT-cta-buttons">
          <a
            href="https://studio.digitaldreamworksagency.com/access"
            className="AT-btn-white"
            style={{ textDecoration: "none" }}
            onClick={() => {
              if (window.fbq) {
                window.fbq('trackCustom', 'RequestDemoOpened', {
                  source: 'call_component'
                });
              }
            }}
          >
            Request Demo Access
          </a>

          <a
            href="https://calendly.com/digi-dreamworks/onboarding-call"
            className="AT-btn-outlined"
            style={{ textDecoration: "none" }}
          >
            Book Commercial Call
          </a>
        </div>
        <p className="AT-cta-note" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', marginTop: '2.5rem', fontWeight: '500' }}>
          Digital Dream Works builds systems used in real operations. No free trials. No generic templates.
        </p>
      </div>
    </>
  );
}
